import { Box, IconButton } from "@mui/material";
import * as React from 'react';
import { FlexBoxColumn, LinkSxSmall } from "../@shared/templates";
import CloseIcon from '@mui/icons-material/Close';
import { setGuideStep } from "../reducers/main/mainReducer";
import { GuideStepEnum } from "../reducers/main/mainModel";
import { useDispatch } from "react-redux";

export type ModalBaseType = {
  children?: React.ReactNode,
  onClose?: () => void,
}

export const GuideCallout = (props: ModalBaseType) => {
    const dispatch = useDispatch();
    const onClose = props.onClose ? props.onClose : () => dispatch(setGuideStep(GuideStepEnum.None));
    return (
        <Box sx={{...FlexBoxColumn, position: "relative" }}>
            <Box sx={{ position: "absolute", top: "0px", right: "0px"}} >
                <IconButton onClick={onClose} sx={{ ...LinkSxSmall, padding: "4px" }} aria-label="Close">
                    <CloseIcon sx={{ fontSize: "1rem" }} />
                </IconButton>
            </Box>
            <Box sx={{ padding: "15px" }} >
                {props.children}    
            </Box>
        </Box>
    );
}

export default GuideCallout;